import { TableClaimsHistoryComponent } from '../../components/table-claims-history/table-claims-history.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-claims-history',
	templateUrl: './card-claims-history.component.html',
	imports: [ CommonModule, TableClaimsHistoryComponent, ListPagerComponent, FormsModule ]
})
export class CardClaimsHistoryComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.claimsList = [];
		this.vm.pageSize = 10;
	}

	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}